import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/cmdb')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/cmdb', ...ROUTE_META['/platform/cmdb'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'CMDB', path: '/platform/cmdb' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/cmdb', ...ROUTE_META['/platform/cmdb'] })),
    ],
  }),
});
